var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<header class=\"lbModal_header\">\n<h2><i class=\"ico-fontawesome-webfont\"></i> Idle Timeout</h2>\n</header>\n<div class=\"lbModal_body\" idle-countdown=\"countdown\">\n<p ng-switch=\"countdown\">\nYou will be logged out in {{ countdown }} {{ vm.getCountdownNoun(countdown) }} due to inactivity.\n</p>\n<div class=\"modalProgress\"><span class=\"modalProgress_indicator\" ng-show=\"countdown > 0\" style=\"width:{{\n    (countdown / vm.timeoutValue) * 100 }}%\"></span></div>\n</div>\n<div class=\"lbModal_actions\">\n<button type=\"button\" class=\"button-primary\" ng-click=\"vm.close()\">Continue using Lightning book</button>\n</div>";
var id1="components/lbTimeoutModal/lbTimeoutModal.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/components/lbTimeoutModal/lbTimeoutModal.html
// module id = 1085
// module chunks = 2